import React, { useEffect, useState } from 'react';
import './styles.css';
import { DISPLAY_VERSION } from '../../../utils/Constants';
import { useTranslation } from 'react-i18next';
import { useFujiAuth } from '../../../auth/useFujiAuth';
import { getValueByLanguage, showNotificationDialog } from '../../../utils';
import Header from '../../../components/header/Header';
import CenterLoading from '../../../components/CenterLoading/CenterLoading';
import MyProfileItem from '../../../components/profile-item/MyProfileItem';
import { useNavigate } from 'react-router-dom';
import FujiModal from '../../../components/fuji-modal/FujiModal';
import isOnline from '../../../utils/network-connect/NetworkConnect';
import { useHomeUrls } from '../../../hooks/useHomeUrls';

/**
 * 図8-1, 図100-1 マイページ画面
 */
const MyProfile = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [openLogout, setOpenLogout] = useState(false);
    const [isLoadingLogout, setIsLoadingLogout] = useState(false);
    const { isAuthenticated, signOut, isLoading } = useFujiAuth();
    const { terms, usage, privacy } = useHomeUrls();

    useEffect(() => {}, [isAuthenticated]);

    /**
     * ログアウトの処理
     *
     */
    const onLogOut = () => {
        setOpenLogout(false);
        if (isOnline()) {
            setIsLoadingLogout(true);
            signOut(false, ({ isSuccessed }: { isSuccessed: boolean }) => {
                if (isSuccessed) {
                    // 購入画面に遷移
                    setIsLoadingLogout(false);
                    navigate('/buy');
                } else {
                    // エラー処理
                    setIsLoadingLogout(false);
                    // 3-E1 ログアウト処理失敗
                    showNotificationDialog(
                        'error',
                        'logout-failed',
                        t('notification.title'),
                        t('error-message.logout.failed'),
                    );
                }
            });
        } else {
            showNotificationDialog('error', '', t('notification.title'), t('error-message.server-error'));
        }
    };

    /**
     * 利用規約の処理
     *
     * @returns {void}
     */
    const onTerms = () => {
        const termsUrl = getValueByLanguage(terms, i18n.language) || terms?.en;
        window.open(termsUrl, '_blank', 'noopener,noreferrer');
    };

    /**
     * 著作権情報
     *
     * @returns {void}
     */
    const onLicensesClick = () => {
        navigate('/profile/licenses');
    };

    /**
     * チケットの使い方の処理
     *
     * @returns {void}
     */
    const onUsage = () => {
        const ticketUsageUrl = getValueByLanguage(usage, i18n.language) || usage?.en;
        window.open(ticketUsageUrl, '_blank', 'noopener,noreferrer');
    };

    /**
     * プライバシーポリシーの処理
     *
     * @returns {void}
     */
    const onPrivacyPolicyClick = () => {
        const ticketUsageUrl = getValueByLanguage(privacy, i18n.language) || privacy?.en;
        window.open(ticketUsageUrl, '_blank', 'noopener,noreferrer');
    };

    return (
        <React.Fragment>
            {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing */}
            {(isLoading || isLoadingLogout) && <CenterLoading overFooter={true} />}
            <Header title={t('header.my-profile')} />
            <div className={`content-container scrollable my-profile-container`}>
                {isAuthenticated ? null : <MyProfileItem to="/auth" title={t('my-profile.login') ?? ''} />}
                {isAuthenticated && <MyProfileItem to="info" title={t('my-profile.userinfo') ?? ''} />}
                {isAuthenticated && (
                    <MyProfileItem to="/bought/used" title={t('my-profile.to-used-ticket-list') ?? ''} />
                )}
                <MyProfileItem to="language" title={t('my-profile.language') ?? ''} isDescription={true} />
                <MyProfileItem title={t('my-profile.usage') ?? ''} onClick={onUsage} />
                <MyProfileItem to="contact" title={t('my-profile.contact') ?? ''} />
                <MyProfileItem title={t('my-profile.terms') ?? ''} onClick={onTerms} />
                <MyProfileItem title={t('my-profile.privacy-policy') ?? ''} onClick={onPrivacyPolicyClick} />
                {isAuthenticated && (
                    <MyProfileItem title={t('my-profile.logout') ?? ''} onClick={() => setOpenLogout(true)} />
                )}
                <button className="license-area">
                    <span onClick={onLicensesClick}>{t('licenses.copyright-information')}</span>
                </button>
                <p style={{ marginTop: 10, fontSize: 14, marginLeft: 10 }}>
                    {t('my-profile.version')}: {DISPLAY_VERSION}
                </p>
                {/* 確認モーダルを表示 */}
                <FujiModal
                    isOpen={openLogout}
                    body={t('modal.logout-confirmation')}
                    txtSubmit={t('modal.ok')}
                    txtCancel={t('modal.cancel') ?? ''}
                    onSubmit={onLogOut}
                    onCancel={() => setOpenLogout(false)}
                />
            </div>
        </React.Fragment>
    );
};

export default MyProfile;
